import React, { useState } from 'react'
import f1 from '../Assets/features/explainqn.png'
import f2 from '../Assets/features/hintstart.png'
import f3 from '../Assets/features/optimize.png'
import f4 from '../Assets/features/randomqn.png'
import f5 from '../Assets/features/approaches.png'
import f6 from '../Assets/features/interviewqn.png'
import f7 from '../Assets/features/interview.png'


const Features = () => {
    const [selectedFeature, setSelectedFeature] = useState(0)
    const featureMenu = ["Explain the question",
        "How do I start",
        "Optimize my solution",
        "Ask doubts",
        "List all solutions",
        "Ask an Interview question",
        "Take a mock interview"
    ]
    const featureImages = [f1, f2, f3, f4, f5, f6, f7]

    return (
        <div className='container-bg'>
            <div className='features-main'>
                <h1 className='section-heading'>What can Codie do?</h1>
                <p>Here's a glimpse of what Codie is capable of. And there's a lot more to explore!</p>
                <div className='features-container'>
                    <div className='features-menu'>
                        {featureMenu.map((item, idx) => (
                            <div key={idx} className={`feature-menu-item feature-menu-item${idx === selectedFeature && "-selected"}`} onClick={() => setSelectedFeature(idx)}>
                                <h2>{item}</h2>
                                {/* <p>{item.description}</p> */}
                            </div>
                        ))}

                    </div>
                    <div className='features-image'>
                        <img src={featureImages[selectedFeature]} alt='feature' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features